import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import type { Context } from 'next-redux-wrapper';
import { applyMiddleware, compose, createStore } from 'redux';
import type { AnyAction, Store, StoreEnhancer } from 'redux';
import { createPromise } from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import type { ReduxStore } from '~/contracts/vdp';
import isServerSideRendering from '~/utilities/isServerSideRendering';
import initialState from './initialState';
import createRootReducer from './rootReducer';

const enhancers: StoreEnhancer[] = [];

const middleware = [
  thunk,
  createPromise({
    promiseTypeSuffixes: ['LOADING', 'SUCCESS', 'ERROR']
  })
];

if (!isServerSideRendering) {
  const { __REDUX_DEVTOOLS_EXTENSION__: devToolsExtension } = window;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
) as StoreEnhancer;

const reducer = (
  state: ReduxStore = initialState,
  action: AnyAction = { type: '' }
) => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...action.payload
    };
  }

  return createRootReducer(state, action);
};

const makeStore = (_context: Context) =>
  createStore(reducer, initialState, composedEnhancers);

const reduxWrapper = createWrapper<Store<ReduxStore>>(makeStore);

export default reduxWrapper;
